<div
  class="slug-input"
  [class.slug-input-edit]="editMode"
  [class.has-error]="hasError"
  >
  <!-- Change warning alert -->
  @if (changeAlert) {
    <div class="alert alert-warning">
      WARNING: Changing the slug will cause any previous links to this article to break and is not recommended.
      To revert to the original slug for this article,
      <a href="#" (click)="resetToOriginal(); $event.preventDefault()">click here</a>.
    </div>
  }

  <!-- Nothing to build the URL from yet -->
  @if (!shouldShowInput && emptyText) {
    <p class="slug-input__empty" [attr.id]="inputId ? inputId + 'Empty' : null">{{ emptyText }}</p>
  }

  <!-- Slug input group -->
  @if (shouldShowInput) {
    <div class="input-group">
      <!-- URL prefix (clickable to activate edit mode) -->
      <div
        class="input-group-addon clickable"
        (click)="activateEditMode()"
        [textContent]="urlPre"
      ></div>
      <!-- Slug input field -->
      <input
        type="text"
        class="form-control"
        [attr.id]="inputId"
        aria-label="Article URL"
        aria-required="true"
        [attr.aria-invalid]="!!hasError || null"
        [attr.aria-describedby]="hasError ? errorId : null"
        [(ngModel)]="currentSlug"
        (focus)="activateEditMode()"
        (input)="onSlugInput(currentSlug)"
        />
      <!-- Reset to automatic button (only shown in edit mode) -->
      @if (editMode) {
        <div
          class="input-group-addon"
          role="button"
          tabindex="0"
          aria-label="reset slug to automatic"
          (keydown)="onResetKeydown($event)"
          (click)="resetToAutomatic()"
          >
          <i class="fa fa-close"></i>
        </div>
      }
    </div>
  }
</div>
